import { render, staticRenderFns } from "./ProductEssentialItem.vue?vue&type=template&id=79087fd8&scoped=true&"
import script from "./ProductEssentialItem.vue?vue&type=script&lang=js&"
export * from "./ProductEssentialItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductEssentialItem.vue?vue&type=style&index=0&id=79087fd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79087fd8",
  null
  
)

export default component.exports